import { render, staticRenderFns } from "./TierPricingDisplay.vue?vue&type=template&id=f184847e&scoped=true&"
import script from "./TierPricingDisplay.vue?vue&type=script&lang=js&"
export * from "./TierPricingDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TierPricingDisplay.vue?vue&type=style&index=0&id=f184847e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f184847e",
  null
  
)

component.options.__file = "TierPricingDisplay.vue"
export default component.exports